import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { MessageCircle, X, Send, CheckCircle2 } from 'lucide-react';
import '../../../../../assets/css/components/customer/home/footer/feedback/FeedBack.css';
import AppContext from '../../../../../context/AppContext';

const FeedbackButton = ({ userRole }) => {
  const { baseUrl, authToken } = React.useContext(AppContext);

  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const resetState = () => {
    setMessage('');
    setSubmitted(false);
  };

  const handleClose = () => {
    setIsOpen(false);
    setTimeout(resetState, 300);
  };
const handleSubmit = async () => {
  if (!message.trim()) {
    Swal.fire({
      icon: 'warning',
      title: 'Required',
      text: 'Please write your feedback message.'
    });
    return;
  }

  if (!authToken) {
    Swal.fire({
      icon: 'error',
      title: 'Authentication Required',
      text: 'Please login first to submit feedback.'
    });
    return;
  }

  setSubmitting(true);

  const endpoint =
    userRole === 'customer'
      ? `${baseUrl}/customer/feedback/submit`
      : `${baseUrl}/provider/feedback/submit`;

  try {
    const response = await axios.post(
      endpoint,
      {
        message: message.trim()
      },
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
          Accept: 'application/json'
        }
      }
    );

    console.log('Feedback Response:', response.data);

    setSubmitted(true);
    setMessage('');

  } catch (err) {

    console.log(
      'Feedback Error:',
      err.response?.data || err.message
    );

   

  } finally {
    setSubmitting(false);
  }
};

  return (
    <>
      {/* Floating Button */}
      <button
        className="fb-float-btn"
        onClick={() => setIsOpen(true)}
      >
        <MessageCircle size={22} />
        <span className="fb-float-btn__label">Feedback</span>
      </button>

      {/* Modal */}
      {isOpen && (
        <div className="fb-overlay" onClick={handleClose}>
          <div
            className="fb-modal"
            onClick={(e) => e.stopPropagation()}
          >

            {!submitted ? (
              <>
                <div className="fb-modal__header">
                  <div className="fb-modal__icon">
                    <MessageCircle size={20} />
                  </div>

                  <div>
                    <h3 className="fb-modal__title">
                      Share Your Feedback
                    </h3>

                    <p className="fb-modal__sub">
                      We'd love to hear your thoughts
                    </p>
                  </div>

                  <button
                    className="fb-modal__close"
                    onClick={handleClose}
                  >
                    <X size={18} />
                  </button>
                </div>

                <div className="fb-modal__body">

                  <label
                    className="fb-field-label"
                    style={{ marginTop: '0' }}
                  >
                    Your Message
                  </label>

                  <textarea
                    className="fb-textarea"
                    placeholder="Tell us what's on your mind..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />

                </div>

                <div className="fb-modal__footer">
                  <button
                    className="fb-cancel-btn"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>

                  <button
                    className="fb-submit-btn"
                    onClick={handleSubmit}
                    disabled={submitting}
                  >
                    {submitting ? (
                      <span className="fb-spinner" />
                    ) : (
                      <>
                        <Send size={15} />
                        Submit
                      </>
                    )}
                  </button>
                </div>
              </>
            ) : (
              <div className="fb-success">
                <div className="fb-success__icon">
                  <CheckCircle2 size={44} />
                </div>

                <h3 className="fb-success__title">
                  Thank You!
                </h3>

                <p className="fb-success__sub">
                  Your feedback has been submitted successfully.
                </p>

                <button
                  className="fb-submit-btn"
                  onClick={handleClose}
                >
                  Close
                </button>
              </div>
            )}

          </div>
        </div>
      )}
    </>
  );
};

export default FeedbackButton;